<template>
    <div class="guide-modal" :style="{ zIndex }">
        <slot></slot>
    </div>
</template>

<script >
// 引导弹窗
import { ref } from 'vue-demi';
import { use } from '@fegobull/webapi';
const __sfc_main = {};
__sfc_main.setup = (__props, __ctx) => {
  const {
    useTeleport,
    useZIndex
  } = use;
  const zIndex = ref(useZIndex());
  zIndex.value = useZIndex();
  !window.FEGOEditor && useTeleport(document.body);
  return {
    zIndex
  };
};
export default __sfc_main;
</script>

<style lang="less" scoped>
.guide-modal {
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.7);
    position: fixed;
    top: 0;
    left: 0;
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
